import { ReactNode } from 'react';

const extractTextFromReactNode = (node: ReactNode): string => {
  if (node === null || node === undefined) {
    return '';
  }

  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }

  if (typeof node === 'boolean') {
    return '';
  }

  if (Array.isArray(node)) {
    return node.map(extractTextFromReactNode).join('');
  }

  if (typeof node === 'object' && 'props' in node) {
    const { props } = node as { props: { children?: ReactNode } };

    if (props?.children) {
      return extractTextFromReactNode(props.children);
    }
  }

  return '';
};

export default extractTextFromReactNode;
